/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import FormFieldCurrency from "components/FormFieldCurrency";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const districtOptions = [
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];

export default function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    checkbox1,
    fullName1,
    taxId1,
    identity,
    identity2,
    national,
    address,
    district,
    province,
    taxAgencyName,
    taxAgencyId,
    makeIn,
    dateMakeIn,
    dateAccepted,
    fullName2,
    taxId2,
    national2,
    address2,
    district2,
    province2,
    phone,
    fax,
    email,
    checkbox2,
    checkbox3,
    checkbox4,
    certificateProperty,
    certificatePropertyByWho,
    certificatePropertyDate,
    organizationInfo,
    organizationName,
    taxId3,
    district3,
    province3,
    address3,
    phone2,
    fax2,
    email2,
    amount1,
    amount2,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox1.name} label={checkbox1.label} value={values.checkbox1} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography variant="h5">I. THÔNG TIN CÁ NHÂN NHẬN THỪA KẾ, QUÀ TẶNG</Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={fullName1.name}
            label={fullName1.label}
            value={values.fullName1}
            error={errors.fullName1 && touched.fullName1}
            success={values.fullName1?.toString().length > 0 && !errors.fullName1}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId1.name}
            label={taxId1.label}
            value={values.taxId1}
            error={errors.taxId1 && touched.taxId1}
            success={values.taxId1?.toString().length > 0 && !errors.taxId1}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={identity.name}
            label={identity.label}
            value={values.identity}
            error={errors.identity && touched.identity}
            success={values.identity?.toString().length > 0 && !errors.identity}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={national.name}
            label={national.label}
            value={values.national}
            error={errors.national && touched.national}
            success={values.national?.toString().length > 0 && !errors.national}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={province.type}
            label={province.label}
            name={province.name}
            value={values.province}
            placeholder={province.placeholder}
            error={errors.province && touched.province}
            success={values.province.length > 0 && !errors.province}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOptions}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography variant="h5">II. VĂN BẢN GIAO NHẬN THỪA KẾ, QUÀ TẶNG</Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={makeIn.name}
            label={makeIn.label}
            value={values.makeIn}
            error={errors.makeIn && touched.makeIn}
            success={values.makeIn?.toString().length > 0 && !errors.makeIn}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={dateMakeIn.name}
            label={dateMakeIn.label}
            value={values.dateMakeIn}
            error={errors.dateMakeIn && touched.dateMakeIn}
            success={values.dateMakeIn?.toString().length > 0 && !errors.dateMakeIn}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={dateAccepted.name}
            label={dateAccepted.label}
            value={values.dateAccepted}
            error={errors.dateAccepted && touched.dateAccepted}
            success={values.dateAccepted?.toString().length > 0 && !errors.dateAccepted}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography variant="h5">III. THÔNG TIN CÁ NHÂN CHO THỪA KẾ, QUÀ TẶNG</Typography>
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={fullName2.name}
            label={fullName2.label}
            value={values.fullName2}
            error={errors.fullName2 && touched.fullName2}
            success={values.fullName2?.toString().length > 0 && !errors.fullName2}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId2.name}
            label={taxId2.label}
            value={values.taxId2}
            error={errors.taxId2 && touched.taxId2}
            success={values.taxId2?.toString().length > 0 && !errors.taxId2}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={identity2.name}
            label={identity2.label}
            value={values.identity2}
            error={errors.identity2 && touched.identity2}
            success={values.identity2?.toString().length > 0 && !errors.identity2}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={national2.type}
            label={national2.label}
            name={national2.name}
            value={values.national2}
            placeholder={national2.placeholder}
            error={errors.national2 && touched.national2}
            success={values.national2.length > 0 && !errors.national2}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={province2.type}
            label={province2.label}
            name={province2.name}
            value={values.province2}
            placeholder={province2.placeholder}
            error={errors.province2 && touched.province2}
            success={values.province2.length > 0 && !errors.province2}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOptions}
            type={district2.type}
            label={district2.label}
            name={district2.name}
            value={values.district2}
            placeholder={district2.placeholder}
            error={errors.district2 && touched.district2}
            success={values.district2.length > 0 && !errors.district2}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address2.name}
            label={address2.label}
            value={values.address2}
            error={errors.address2 && touched.address2}
            success={values.address2?.toString().length > 0 && !errors.address2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone.name}
            label={phone.label}
            value={values.phone}
            error={errors.phone && touched.phone}
            success={values.phone?.toString().length > 0 && !errors.phone}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax.name}
            label={fax.label}
            value={values.fax}
            error={errors.fax && touched.fax}
            success={values.fax?.toString().length > 0 && !errors.fax}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email.name}
            label={email.label}
            value={values.email}
            error={errors.email && touched.email}
            success={values.email?.toString().length > 0 && !errors.email}
          />
        </Grid>

        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography variant="h5">IV. LOẠI TÀI SẢN ĐƯỢC NHẬN THỪA KẾ, QUÀ TẶNG</Typography>
        </Grid>

        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox2.name} label={checkbox2.label} value={values.checkbox2} />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox3.name} label={checkbox3.label} value={values.checkbox3} />
        </Grid>
        <Grid item xs={12} lg={4} style={{ paddingTop: 0 }}>
          <SwitchField name={checkbox4.name} label={checkbox4.label} value={values.checkbox4} />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={certificateProperty.name}
            label={certificateProperty.label}
            value={values.certificateProperty}
            error={errors.certificateProperty && touched.certificateProperty}
            success={
              values.certificateProperty?.toString().length > 0 && !errors.certificateProperty
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={certificatePropertyByWho.name}
            label={certificatePropertyByWho.label}
            value={values.certificatePropertyByWho}
            error={errors.certificatePropertyByWho && touched.certificatePropertyByWho}
            success={
              values.certificatePropertyByWho?.toString().length > 0 &&
              !errors.certificatePropertyByWho
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            name={certificatePropertyDate.name}
            label={certificatePropertyDate.label}
            value={values.certificatePropertyDate}
            error={errors.certificatePropertyDate && touched.certificatePropertyDate}
            success={
              values.certificatePropertyDate?.toString().length > 0 &&
              !errors.certificatePropertyDate
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={organizationInfo.name}
            label={organizationInfo.label}
            value={values.organizationInfo}
            error={errors.organizationInfo && touched.organizationInfo}
            success={values.organizationInfo?.toString().length > 0 && !errors.organizationInfo}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={organizationName.name}
            label={organizationName.label}
            value={values.organizationName}
            error={errors.organizationName && touched.organizationName}
            success={values.organizationName?.toString().length > 0 && !errors.organizationName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId3.name}
            label={taxId3.label}
            value={values.taxId3}
            error={errors.taxId3 && touched.taxId3}
            success={values.taxId3?.toString().length > 0 && !errors.taxId3}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={district3.type}
            label={district3.label}
            name={district3.name}
            value={values.district3}
            placeholder={district3.placeholder}
            error={errors.district3 && touched.district3}
            success={values.district3.length > 0 && !errors.district3}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={provinceOptions}
            type={province3.type}
            label={province3.label}
            name={province3.name}
            value={values.province3}
            placeholder={province3.placeholder}
            error={errors.province3 && touched.province3}
            success={values.province3.length > 0 && !errors.province3}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address3.name}
            label={address3.label}
            value={values.address3}
            error={errors.address3 && touched.address3}
            success={values.address3?.toString().length > 0 && !errors.address3}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={phone2.name}
            label={phone2.label}
            value={values.phone2}
            error={errors.phone2 && touched.phone2}
            success={values.phone2?.toString().length > 0 && !errors.phone2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={fax2.name}
            label={fax2.label}
            value={values.fax2}
            error={errors.fax2 && touched.fax2}
            success={values.fax2?.toString().length > 0 && !errors.fax2}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={email2.name}
            label={email2.label}
            value={values.email2}
            error={errors.email2 && touched.email2}
            success={values.email2?.toString().length > 0 && !errors.email2}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography variant="h5">VI. THU NHẬP TỪ NHẬN THỪA KẾ, QUÀ TẶNG</Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormFieldCurrency
            name={amount1.name}
            label={amount1.label}
            value={values.amount1}
            error={errors.amount1 && touched.amount1}
            success={values.amount1?.toString().length > 0 && !errors.amount1}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography variant="h5">
            VII. THU NHẬP ĐƯỢC MIỄN GIẢM THEO HIỆP ĐỊNH TRÁNH ĐÁNH THUẾ HAI LẦN
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormFieldCurrency
            name={amount2.name}
            label={amount2.label}
            value={values.amount2}
            error={errors.amount2 && touched.amount2}
            success={values.amount2?.toString().length > 0 && !errors.amount2}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
